import { createSlice } from "@reduxjs/toolkit";

export const get_notifications = createSlice({
  name: "notifications_contents",
  initialState: {
    value: { status: false, data: [] },
  },
  reducers: {
    updateStoreNotifications: (state, action) => {
      state.value.status = true;
      state.value.data = action.payload;
    },
    removeNotificationById: (state, action) => {
      state.value.status = true;
      const existingData = [...state.value.data];
      state.value.data.forEach((item, index) => {
        if (action.payload === item.id) {
          existingData.splice(index, 1);
        }
      });
      state.value.data = existingData;
    },
  },
});

export const { updateStoreNotifications, removeNotificationById } =
  get_notifications.actions;

export default get_notifications.reducer;
